import { useEffect, useState } from 'react'

// Tailwind CSS breakpoints in pixels
const TAILWIND_BREAKPOINTS = {
  sm: 640, // Small screens
  md: 768, // Medium screens
  lg: 1024, // Large screens
  xl: 1280, // Extra large screens
  '2xl': 1536 // 2XL screens
}

const useIsMobileBrowser = () => {
  const [isMobileBrowser, setIsMobileBrowser] = useState(false)

  useEffect(() => {
    const checkMobileBrowser = () => {
      // Check by user agent
      const mobileKeywords = [
        'Android',
        'webOS',
        'iPhone',
        'iPad',
        'iPod',
        'BlackBerry',
        'IEMobile',
        'Opera Mini'
      ]
      const userAgent = navigator.userAgent

      const isMobileByUserAgent = mobileKeywords.some((keyword) =>
        userAgent.includes(keyword)
      )

      // Check if screen width is less than Tailwind's 'md' breakpoint (768px)
      // This matches the 'md:' prefix in Tailwind classes
      const isMobileByScreenSize = window.innerWidth < TAILWIND_BREAKPOINTS.md

      // Device is considered mobile if either condition is true
      const result = isMobileByUserAgent || isMobileByScreenSize
      setIsMobileBrowser(result)
    }

    // Initial check
    checkMobileBrowser()

    // Add a listener for window resize events
    window.addEventListener('resize', checkMobileBrowser)

    // Clean up the listener when the component unmounts
    return () => {
      window.removeEventListener('resize', checkMobileBrowser)
    }
  }, [])

  return isMobileBrowser
}

export default useIsMobileBrowser
